<template>
  <v-container>
    <v-row>
      <v-col class="py-0">
        <content-header
          v-if="!hideHeader"
          :title="section.text"
          titlePlaceholder="Untitled Section"
          :description="section.description"
          descriptionPlaceholder="...add some general notes"
          @updateTitle="
            updateSectionText({ contextId: context.id, sectionId: sectionId, text: $event })
          "
          @updateDescription="
            updateSectionDescription({
              contextId: context.id,
              sectionId: sectionId,
              description: $event
            })
          "
          @traverseOut="traverse({ ...$event, toIndex: 0 })"
        >
          <v-col class="shrink py-0"><v-btn text @click="createNewItem">Add Page</v-btn></v-col>
        </content-header>
      </v-col>
    </v-row>

    <transition-group name="flip-list" tag="div" class="row">
      <v-col
        lg="4"
        md="6"
        sm="12"
        class=""
        v-for="page in sectionPages"
        :key="page.id"
        style="position: relative;"
      >
        <page-card-drop-helper :item="page"></page-card-drop-helper>
        <page-card :page="page" :ref="page.id" @mousedown="setSelectedPageId({ page: page.id })"></page-card>
      </v-col>
      <v-col key="new" lg="4" md="6" sm="12" class="" style="position: relative;">
        <page-card-drop-helper
          :item="{ order: sectionPages.length, section: sectionId }"
        ></page-card-drop-helper>
        <v-btn text block @click="createNewItem" style="opacity: 0.6;" height="122px">
          ADD NEW PAGE
        </v-btn>
      </v-col>
    </transition-group>
  </v-container>
</template>

<script>
import PageCard from './PageCard';
import PageCardDropHelper from './PageCardDropHelper';
import ContentHeader from '../ContentHeader';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  props: ['sectionId', 'hideHeader'],
  components: { PageCard, PageCardDropHelper, ContentHeader },
  computed: {
    ...mapState('views/context', ['selectedPageId', 'focusTo', 'showResourcePanel']),
    ...mapState('pages', ['pages']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['context', 'userCanEdit']),
    ...mapGetters('pages', ['pagesBySection']),
    section() {
      return this.context.sections[this.sectionId];
    },
    sectionPages() {
      return this.pagesBySection[this.sectionId];
    }
  },
  methods: {
    ...mapMutations('views/context', ['setSelectedPageId']),
    ...mapActions('pages', ['addPage']),
    ...mapActions('context', ['updateSectionText', 'updateSectionDescription']),
    async createNewItem() {
      if (!this.userCanEdit) {
        return;
      }
      const order = this.sectionPages.length;
      const id = await this.addPage({
        contextId: this.context.id,
        section: this.sectionId,
        order
      });
      this.$nextTick(() => {
        //this.selected = id;
        //this.$emit('focusEdit', id);
        this.$refs[id][0].focusTitle();
      });
    }
  }
};
</script>

<style></style>
